module.exports = __webpack_public_path__ + "img/file-music.16d8ff34.svg";